import React from 'react';
import { Resource, Labeled } from 'react-admin';
import CadastroUsuario from "./components/cadastros/Usuario";
import CadastroEmpresa from "./components/cadastros/Enterprise";
import QrCode from "./components/qrforms";
import Audit from "./components/audit";
import Report from "./components/reports";
import MyAudit from "./components/audit/MyAudits";
import FormLayout from "./components/form_layout";
import Folder from './components/folder';

export const getTropicalResources = (permission) => [
    <Resource
        key="pop02"
        name="pop02"
        list={FormLayout}
        options={{ label: "Sementes Tropical", type: "2" }}
    />,
    (permission?.name === "SUPORTE" || permission?.name === "ADMINISTRADOR") && (
        <Resource key="Usuario" name="Usuario" list={CadastroUsuario} options={{ label: "Usuario" }} />
    ),

];

export const getRanchoAlegreResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Distribuição interna de ração", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Distribuição interna de ração", type: "2" }} />,
];

export const getSbrResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "POP 01", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "POP 02", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "POP 03", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "POP 04", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "POP 05", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "POP 06", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "POP 07", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "Processos produtivos", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "POP 09", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "POP 10", type: "10" }} />,
];

export const getHeinekenResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "PORTARIA IND/REG", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "CD", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "LABORATÓRIO", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "OFICINA", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "PORTARIA PRINCIPAL", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "AUDITÓRIO", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "VIVÊNCIA", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "AMBULATÓRIO", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "RH", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "ALMOXARIFADO", type: "10" }} />,
];

export const getStandardResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "POP 01", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "POP 02", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "POP 03", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "POP 04", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "POP 05", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "POP 06", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "POP 07", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "POP 08", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "POP 09", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "POP 10", type: "10" }} />,
];

export const getNutriPuraResources = () => [
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Controle de Não Conformidades", title: "TESTE", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "Manutenção Preventiva", type: "4" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "Atendimento a Reclamação de clientes", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "Higiene e Saúde do colaborador", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "Qualificação de fornecedor", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "Recebimento de Matérias primas", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "Limpeza de Instalações e Equipamentos", type: "10" }} />,
    <Resource key="pop12" name="pop12" list={FormLayout} options={{ label: "Calibração de Equipamentos e balanças", type: "12" }} />,
    <Resource key="pop13" name="pop13" list={FormLayout} options={{ label: "Controle de Pragas", type: "13" }} />,
    <Resource key="pop15" name="pop15" list={FormLayout} options={{ label: "Avaliação de Produto Acabado", type: "15" }} />,
    <Resource key="pop18" name="pop18" list={FormLayout} options={{ label: "Expedição de Produto Acabado", type: "18" }} />,
    <Resource key="pop19" name="pop19" list={FormLayout} options={{ label: "Devolução de produto Acabado", type: "19" }} />,
    <Resource key="pop23" name="pop23" list={FormLayout} options={{ label: "Homogeneidade de mistura", type: "23" }} />,
    <Resource key="pop24" name="pop24" list={FormLayout} options={{ label: "Segurança do Trabalho", type: "24" }} />,
];

export const getGeneralResources = (permission) => [
    <Resource key="myaudit" name="myaudit" list={MyAudit} options={{ label: "Minhas solicitações" }} />,
    <Resource key="folder" name="folder" list={Folder} options={{ label: "Pastas" }} />,

    (permission?.name === "SUPORTE" || permission?.name === "ADMINISTRADOR") && (
        <Resource key="Usuario" name="Usuario" list={CadastroUsuario} options={{ label: "Usuario" }} />
    ),
    (permission?.name === "SUPORTE" || permission?.name === "ADMINISTRADOR") && (
        <Resource key="QrCode" name="QrCode" list={QrCode} options={{ label: "QR Code" }} />
    ),
    (permission?.name === "SUPORTE" || permission?.name === "ADMINISTRADOR") && (
        <Resource key="audit" name="audit" list={Audit} options={{ label: "Auditoria" }} />
    ),
    permission?.name === "SUPORTE" && (
        <Resource key="report" name="report" list={Report} options={{ label: "Relatório Forms" }} />
    ),

    permission?.name === "SUPORTE" && (
        <Resource key="Empresa" name="Empresa" list={CadastroEmpresa} options={{ label: "Empresa" }} />
    ),
];

export const getPepTechResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Recebimento", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Reator", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Filtro Prensa", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "Microfiltro", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "Membrana", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "Evaporador", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "Monitoramento Operacionais empresas tercerizadas", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "Acompanhamento do produto semiacabado e acabado", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "Limpeza/Sanitização", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "Passagem de turno", type: "10" }} />,
];

export const getGrupoAli = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Registros", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Estrutura das Pecuárias", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Controlo de Engorda", type: "3" }} />,
];

export const getIafbResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "IDENTIFICAÇÃO", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "VARIÁVEIS PRODUTIVAS E SOCIOECONÔMICA", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "SOLO E CULTURAS", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "ORDENHA", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "REBANHO", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "NUTRIÇÃO", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "SANIDADE ANIMAL", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "REPRODUÇÃO", type: "8" }} />,
];

export const getMcassabResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Recebimento", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Housekeeping", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Expedição", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "Processos Produtivos", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "Portaria/Pátio", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "Recursos Humanos", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "Segurança do Trabalho", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "Enfermaria", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "Laboratórios", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "Almoxarifado", type: "10" }} />,
    <Resource key="pop11" name="pop11" list={FormLayout} options={{ label: "Qualidade Assegurada", type: "11" }} />,
    <Resource key="pop12" name="pop12" list={FormLayout} options={{ label: "Compliance", type: "12" }} />,
];

export const getNutroesteResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Recebimento", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Housekeeping", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Expedição de Produto", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "Processos Produtivos", type: "4" }} />,
];

export const getVaccinarResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Recebimento", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Limpeza ", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Secagem", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "Monitoramento Proteína", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "Processos Produtivos", type: "5" }} />,
];

export const getGranjaBuritiResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Financeiro", type: "1" }} />,
];

export const getCamdaResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Recebimento", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Qualidade produto", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Expedição", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "Housekeeping", type: "4" }} />,
];

export const getTecnomercResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "CONVERSÃO ALIMENTAR", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "PROCESSOS PRODUTIVOS", type: "2" }} />,
];

export const getApresentacaoResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "MANEJO PRODUTIVO", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "PÁTIO", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "RECEBIMENTO", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "EXPEDIÇÃO", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "MANUTENÇÃO", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "MONITORAMENTO OPERACIONAL", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "SEGURANÇA DO TRABALHO", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "QUALIDADE ASSEGURADA", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "COMPLIANCE", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "RECURSOS HUMANOS", type: "10" }} />,
];

export const get2MNResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "HOUSEKEEPING ADM", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "VESTIÁRIOS", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "PRODUÇÃO", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "ÁREA EXTERNA", type: "4" }} />,
];

export const getHerpanResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Revisão de Documentos", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Fornecedores, Recebimento e Devolução", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Registros de Limpeza", type: "3" }} />,
    <Resource key="pop04" name="pop04" list={FormLayout} options={{ label: "RH", type: "4" }} />,
    <Resource key="pop05" name="pop05" list={FormLayout} options={{ label: "Potabilidade da Agua", type: "5" }} />,
    <Resource key="pop06" name="pop06" list={FormLayout} options={{ label: "Produção", type: "6" }} />,
    <Resource key="pop07" name="pop07" list={FormLayout} options={{ label: "Manutenção", type: "7" }} />,
    <Resource key="pop08" name="pop08" list={FormLayout} options={{ label: "MIP ", type: "8" }} />,
    <Resource key="pop09" name="pop09" list={FormLayout} options={{ label: "Tratamento de Resíduos", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "Rastreabilidade ", type: "10" }} />,
];

export const getFranciosiResources = () => [
    <Resource key="pop01" name="pop01" list={FormLayout} options={{ label: "Agricultura", type: "1" }} />,
    <Resource key="pop02" name="pop02" list={FormLayout} options={{ label: "Irrigação", type: "2" }} />,
    <Resource key="pop03" name="pop03" list={FormLayout} options={{ label: "Frotas", type: "3" }} />,
    <Resource key="pop04" name="pcm" list={FormLayout} options={{ label: "PCM", type: "4" }} />,
    <Resource key="pop05" name="pcm_leves" list={FormLayout} options={{ label: "Veículos Leves", type: "5" }} />,
    <Resource key="pop06" name="pcm_revisao" list={FormLayout} options={{ label: "Revisão de Máquinas", type: "6" }} />,
    <Resource key="pop07" name="pcm_checklist" list={FormLayout} options={{ label: "Checklist de Máquinas", type: "7" }} />,
    <Resource key="pop08" name="pcm_inspencao" list={FormLayout} options={{ label: "Inspeção de máquinas", type: "8" }} />,
    <Resource key="pop09" name="pcm_ordem" list={FormLayout} options={{ label: "Ordem de serviço", type: "9" }} />,
    <Resource key="pop10" name="pop10" list={FormLayout} options={{ label: "Gestão Patrimonial ", type: "10" }} />,
    <Resource key="pop11" name="pop11" list={FormLayout} options={{ label: "Comercial", type: "11" }} />,
    <Resource key="pop12" name="pop12" list={FormLayout} options={{ label: "Logística ", type: "12" }} />,
    <Resource key="pop13" name="pop13" list={FormLayout} options={{ label: "RH ", type: "13" }} />,
];